
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IPlot } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";
import { DriverAssignmentService } from "@services/driverAssignment.service";
import { IHistoricalDay, JourneyService } from "@services/journey.service";
import { PlotService } from "@services/plot.service";
import { PlotEventService } from "@services/plotEvent.service";
import { VehicleService } from "@services/vehicle.service";
import { StateService } from "@uirouter/angularjs";
import * as angular from "angular";
import * as moment from "moment";
import "./vehiclemap.scss";

export class VehicleMapController {
    vehicleInterval: angular.IPromise<any>;

    selectedVehicle: IVehicle;
    vehicles: IVehicle[] = [];
    vehiclesDisplay: IVehicle[] = [];

    showMobileMap = false;

    historicalDay: IHistoricalDay;

    isToday = true;
    loadingHistoricalData = false;
    historicalDate = moment().toDate();

    selectedHistoricalPlot: IPlot;

    static $inject = ["$q", "$timeout", "$interval", "$state", "vehicleService", "driverAssignmentService", "journeyService", "plotService", "plotEventService"];

    constructor(
        private $q: angular.IQService,
        private $timeout: angular.ITimeoutService,
        private $interval: angular.IIntervalService,
        private $state: StateService,
        private vehicleService: VehicleService,
        private readonly driverAssignmentService: DriverAssignmentService,
        private journeyService: JourneyService,
        private plotService: PlotService,
        private plotEventService: PlotEventService) {

        // Update every minute
        this.vehicleInterval = this.$interval(() => {
            this.updateData();
        }, 60 * 1000);
    }

    onMapLoaded(veriMap: IVeriMapComponent) {
        //this.updateData(true);
        //console.log("onmapload");
    }

    setSelectedVehicle(vehicle: IVehicle) {
        this.selectedVehicle = vehicle;

        if (this.selectedVehicle == null) {
            return;
        }

        const sanitizedReg = this.vehicleService.getSanitizedReg(this.selectedVehicle);
        const params: any = { "vehicle": sanitizedReg };
        if (!sanitizedReg) {
            params.panel = "";
        }

        this.$state.go(this.$state.current.name, params, { location: true, notify: false, reload: false });

        this.loadVehicleDataForDay();
    }

    setDisplayVehicles(vehicles: IVehicle[]) {
        this.vehiclesDisplay = [];

        vehicles.forEach(v => {
            if (v.Plot != null) {
                this.vehiclesDisplay.push(v);
            }
        });
    }

    showAllVehicles() {
        this.selectedVehicle = null;
    }

    //showAsMap(show: boolean) {
    //    console.log("%cshowAsMap", "color: blue");
    //    this.showMobileMap = show;
    //}

    onDateChanged(date: Date) {
        this.historicalDate = date;
        this.isToday = moment().isSame(this.historicalDate, "d");

        this.loadVehicleDataForDay();
    }

    historicalPlotSelected(plot: IPlot) {
        this.selectedHistoricalPlot = plot;
    }

    private loadVehicleDataForDay() {
        this.loadingHistoricalData = true;

        const selectedDateIsToday = moment(this.historicalDate).isSame(moment(), "d");

        this.journeyService
            .getAllJourneyDataForVehicle(this.selectedVehicle, this.historicalDate, selectedDateIsToday)
            .then(historicalDay => {
                this.historicalDay = historicalDay;
            })
            .finally(() => {
                this.loadingHistoricalData = false;
            });
    }

    private updateData(firstRun: boolean = false): angular.IPromise<any> {
        return this.driverAssignmentService
            .getVehiclesWithDrivers({ includeLatestPlots: true, includePeripheralMappings: true })
            .then(vehicles => {
                this.vehicles = vehicles;
                this.setDisplayVehicles(vehicles);

                if (firstRun) {
                    this.preselectPageState();
                }
            })
            .catch(e => {
                console.warn("updateData", e);
            });
    }

    private preselectPageState() {
        if (!this.$state.params["vehicle"]) {
            return;
        }

        const vehicle = this.vehicleService.findVehicleByReg(this.vehicles, this.$state.params["vehicle"]);
        if (vehicle) {
            this.$timeout(() => {
                this.setSelectedVehicle(vehicle);
            }, 500);
        }
    }
}
